<template>

    <div class="ap-container">

        <div class="ap-bloc-container">

            <div class="lp-logo-container">

                <img class="lp-logo" :src="logoSrc">

            </div>

            <p class="screen-subtitle">{{ $t(`login_provider_tuto_web_title_${ provider }`)}}</p>

            <div v-for="(item, index) in advices" class="grey-bloc-container">

                <div class="ghost-bloc" v-show="step >= item">

                    <div class="grey-bloc" :class="{ 'anim-grey-bloc': item !== 1}">

                        <div class="grey-bloc-left">

                            <div v-if="index + 1 === step" class="ap-circle ap-dark-circle">{{ item }}</div>

                            <div v-else class="ap-circle ap-green-circle">

                                <img class="ap-check" src="/img/icons/check-white.svg">

                            </div>




                        </div>

                        <div class="grey-bloc-right">

                            <markdown class="grey-bloc-title" :text="convertProviderSubtitle(item)" :blank="true"></markdown>

                            <markdown class="grey-bloc-subtitle" :text="convertProviderText(item)" :blank="true"></markdown>

                        </div>


                    </div>

                </div>

            </div>

            <mq-layout :mq="['sm', 'md']" class="fixed-container">

                <button v-if="lastItem" class="btn btn-big btn-green" @click="done">{{ $t('global_cta_done') }}</button>

                <button v-else class="btn btn-big btn-blue" @click="nextStep">{{ $t('global_cta_next') }}</button>

            </mq-layout>

            <mq-layout mq="lg" class="fixed-container" :class="{ 'fixed-container-end': tutoFinish }">

                <button class="btn btn-blue" :class="{ 'btn-green': tutoFinish }" @click="nextStep">{{ computedBtnNext }}</button>

                <div v-if="electedProvider" class="separator"></div>

                <button v-if="electedProvider" class="btn btn-grey btn-help" @click="needHelp">{{ computedBtnHelp }}</button>

            </mq-layout>

        </div>

    </div>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import Markdown from '@/components/Markdown'
import ModalErrorGoogle from '@/components/modal/ModalErrorGoogle'

export default {

    name: 'login-provider-tuto-web',

    components: { Markdown, ModalErrorGoogle },

    props: {

        provider: {
            type: String,
            default: ''
        },

        logoSrc: {
            type: String,
            default: ''
        }

    },

    computed: {

        lastItem: function () {
            return this.step >= this.advices
        },

        tutoFinish: function () {
            return this.step > this.advices
        },

        computedBtnNext: function () {

            return this.tutoFinish ? this.$t('login_provider_tuto_web_everything_done') : this.$t('login_provider_tuto_web_it_is_done')

        },

        computedBtnHelp: function () {

            return this.tutoFinish ? this.$t('login_provider_tuto_web_lost_help') : this.$t('login_provider_tuto_web_need_help')

        },

        electedProvider: function () {

            return this.provider === 'google' || this.provider === 'outlook'

        }
    },

    data () {
        return {
            advices: 0,
            step: 1
        }
    },

    mounted () {

        let counter = 1
        let bool = true

        while (bool) {

            if (this.$i18n.messages.en[`login_provider_tuto_web_subtitle_${counter + 1}_${this.provider}`]) {
                counter++
            } else {
                bool = false
            }
        }

        this.advices = counter
    },

    methods: {

        back () {

            this.$emit('back')

        },

        nextStep () {

            if (this.step <= this.advices) {

                this.step = this.step + 1

                setTimeout(function () {

                    try {

                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })

                    } catch (ignored) {
                        // do nothing
                    }

                }, 10)

            } else {

                this.next()

            }
        },

        needHelp () {

            if (this.provider === 'google') {

                Tag.clickAmplitude(this, 'help', 'google')

                switch (I18n.get(this)) {
                    case 'fr':
                        window.open('https://cleanfox.io/blog/astuces-gmail/comment-se-connecter-a-cleanfox-avec-une-adresse-gmail/')
                        break
                    default:
                        window.open('https://cleanfox.io/blog/gmail-tips/how-to-log-into-cleanfox-with-a-gmail-address/')
                }

            } else if (this.provider === 'outlook') {

                Tag.clickAmplitude(this, 'help', 'outlook')

                switch (I18n.get(this)) {
                    case 'fr':
                        window.open('https://cleanfox.io/blog/astuces-hotmail-outlook/connexion_cleanfox-microsoft/')
                        break
                    default:
                        window.open('https://cleanfox.io/blog/hotmail-outlook-tips/how-do-i-connect-to-cleanfox-with-an-outlook-hotmail-address/')
                }

            }

        },

        done () {

            this.next()

        },

        convertProviderSubtitle (index) {
            return this.$t(`login_provider_tuto_web_subtitle_${index}_${this.provider}`)
        },

        convertProviderText (index) {
            return this.$t(`login_provider_tuto_web_description_${index}_${this.provider}`)
        },

        next () {

            Tag.clickAmplitude(this, 'understood')

            this.$emit('next')

        },

        goAppPass () {

            this.$emit('goAppPass')

        }

    }
}
</script>

<style scoped lang="scss">

    .ap-container {
        @media screen and (min-width: $above-tablet-length) {
            width: 100%;
            display: flex;
            justify-content: center;
            flex-grow: 1;
            align-items: center;
            padding: 50px;
        }
    }

    .ap-bloc-container {
        padding: 26px 16px 32px;
        background-color: $white;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        color: $midnight;
        align-items: center;
        margin-bottom: 108px;
        @media screen and (min-width: $above-tablet-length) {
            padding: 40px;
            max-width: 480px;
            border-radius: 8px;
            box-shadow: 0 2px 10px 3px rgba(0, 0, 0, 0.15);
            height: fit-content;
        }
    }

    .lp-logo-container {
        @media screen and (min-width: $above-tablet-length) {
            width: 144px;
            height: 72px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .lp-logo {
        max-width: 128px;
        max-height: 72px;
        object-fit: contain;
        @media screen and (min-width: $above-tablet-length) {

        }
    }

    .screen-subtitle {
        font-size: 17px;
        line-height: 1.41;
        margin-top: 11px;
        text-align: left;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 24px;
        }
    }

    .grey-bloc-container {
        overflow: hidden;
        width: 100%;
    }

    .ghost-bloc {
        position: relative;
    }

    .grey-bloc {
        width: 100%;
        border-radius: 8px;
        background-color: #f1f1f1;
        padding: 16px;
        display: flex;
        flex-direction: row;
        margin-top: 16px;
        position: relative;
        top: 0;
        left: 0;
    }

    .grey-bloc-left {
        width: 40px;
    }

    .ap-circle {
        width: 24px;
        height: 24px;
        font-size: 15px;
        font-weight: bold;
        line-height: 1.6;
        color: $white;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ap-dark-circle {
        background-color: $midnight;
    }

    .ap-green-circle {
        background-color: $green;
    }

    .ap-check {
        width: 15px;
        object-fit: contain;
    }

    .grey-bloc-right {
        width: 100%;
        text-align: left;
    }

    .grey-bloc-title {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        letter-spacing: -0.2px;
    }

    .grey-bloc-subtitle {
        font-size: 17px;
        line-height: 1.41;
        margin-top: 8px;
        display: block;
    }

    .fixed-container {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 20px 16px 32px;
        background-color: $white;
        @media screen and (min-width: $above-tablet-length) {
            position: static;
            padding: 16px 0 0;
            display: flex;
            flex-direction: row;
        }
    }

    .fixed-container-end {
        @media screen and (min-width: $above-tablet-length) {
            flex-direction: column;
        }
    }

    .btn-help {
        color: $aquamarine;
    }

    .separator {
        width: 16px;
        height: 8px;
    }

    .anim-grey-bloc {
        animation: animap2show 500ms ease-in-out 50ms 1 normal forwards;
        opacity: 0;
    }

    @keyframes animap2show {

        0% {
            top: 200px;
            opacity: 0;
        }

        100% {
            opacity: 1;
            top: 0;
        }
    }
</style>
